import React from "react";
import { t } from "ttag";

import { IReviewQueryFacets } from "../../../models/reviews.interfaces";
import { useAppSelector } from "../../reducers";
import { defaultState } from "../defaults";
import { RatingFilterOption } from "./RatingFilterOption";

const FACET_TYPE: IReviewQueryFacets = "rating";

interface IProps {
    starHasStroke?: boolean;
}

export const RatingFilter = (props: IProps) => {
    const ratingFacet = useAppSelector((state) => {
        const reviewsState = state.reviews || defaultState;
        return (
            reviewsState.data.facets.find(
                (facet) => facet.type === FACET_TYPE,
            ) || null
        );
    });

    const options = ratingFacet ? ratingFacet.options : [];
    return (
        <div className="customer-review__side-filters__menu">
            <div className="customer-review__side-filters__title">
                <h3>
                    Filter Reviews
                    <span aria-hidden="true">
                        <sup className="customer-review__side-filters__title--superscript">
                            §
                        </sup>
                    </span>
                </h3>
            </div>
            <div className="customer-review__side-filters__menu-item">
                <span className="ada-screenreader-only">
                    {t`Activating this element will cause content on the page to be updated`}
                </span>
                <fieldset>
                    <legend>
                        <div className="customer-review__side-filters__menu-title">
                            Rating
                        </div>
                    </legend>
                    <div className="customer-review__side-filters__menu-content">
                        {options.map((option) => (
                            <RatingFilterOption
                                key={option.option_id}
                                facetType={FACET_TYPE}
                                option={option}
                                starHasStroke={props.starHasStroke}
                            />
                        ))}
                    </div>
                </fieldset>
            </div>
        </div>
    );
};
